<template>
<div class="qa-info container">
  <div>
    <Header :title="type==='submit'?'提交成功':'已录入'"></Header>
  <div class="result-info">
    <img src="../../../assets/images/activity/form-verification-right.png" alt="">
    <div class="result-info-text">
      {{type==='submit'?'提交成功':'已录入'}}
      </div>
    <div style="color:grey;font-size:13px">
      请核对基本信息
    </div>
  </div>

  <div class="info">
    <div class="info-item">
      <div class="title">博世料号</div>
      <div class="text">{{codeInfo.partNo}}</div>
    </div>
    <div class="info-item">
      <div class="title">产品名称</div>
      <div class="text">{{codeInfo.partName}}</div>
    </div>
    <div class="info-item">
      <div class="title">销售日期</div>
      <div class="text">{{parseTime(codeInfo.initTime,'{y}-{m}-{d}')}}</div>
    </div>
    <div class="info-item">
      <div class="title">销售方名称</div>
      <div class="text">{{codeInfo.workshopName}}</div>
    </div>
    <div class="info-item">
      <div class="title">销售地址</div>
      <div class="text">{{codeInfo.workshopAddress}}</div>
    </div>
    <div class="info-item">
      <div class="title">销售/安装人员</div>
      <div class="text">{{codeInfo.workshopPerson}}</div>
    </div>
    <div class="info-item">
      <div class="title">车主手机号</div>
      <div class="text">{{codeInfo.consumerMobile}}</div>
    </div>
    <div class="info-item">
      <div class="title">安装时里程数</div>
      <div class="text">{{codeInfo.initMileage}}&nbsp;KM</div>
    </div>
    <div class="info-item">
      <div class="title">车型</div>
      <div class="text">{{codeInfo.carName}}</div>
    </div>
  </div>

    <div class="footer">
      <div class="btn submit-btn" @click="reset()">重新编辑信息</div>
      <div class="btn submit-btn" @click="gotoWeb()">确定</div>
    </div>
  </div>
  <van-overlay :show="submitDialogShow" @click="submitDialogShow = false">
  <div class="wrapper" @click.stop>
    <div class="block">
      <p class="wrapper-title">{{ submitDialogText }}</p>
      <p class="wrapper-text">&ensp;(领取方法：微信扫码电瓶壳体二维码，根据提示即可领取)</p>
      <div class="wrapper-button">
        <van-button v-if="!backGbb" type="primary" @click="submitDialogShow = false;$router.push({ name: 'quality-assurance-ws' })">知道了</van-button>
        <van-button v-else type="primary" @click="submitDialogShow = false;$router.push({ name: 'gbb-qrCode-scan' })">知道了</van-button>
      </div>
    </div>
  </div>
</van-overlay>
</div>
</template>

<script>
import Header from '../../../components/header.vue'
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
export default {
  components: { Header },
  data () {
    return {
      value: '',
      type: '',
      code: '',
      codeInfo: {},
      isTrayCode: false,
      trayInfo: {},
      codeType: '',
      warrantyId: '',
      submitDialogText: '',
      submitDialogShow: false,
      backGbb: false
    }
  },
  created () {
    if (this.$route.query.scanAdd) {
      this.backGbb = true
    }
    this.type = this.$route.query.type
    this.warrantyId = this.$route.query.warrantyId
    let data = sessionStorage.getItem('codeInfo') || ''
    this.codeInfo = JSON.parse(data)
    console.log(this.codeInfo)
  },
  methods: {
    parseTime: commonUtils.parseTime,
    reset () {
      this.$router.push({ name: 'quality-assurance-ws-info' })
    },
    gotoWeb () {
      if (this.type === 'submit') {
        // AGM类型电瓶
        this.submitDialogText = this.codeInfo.productKey === '070044' ? '电子质保激活成功，AGM电瓶质保期延长至24个月，请通知车主领取' : '电子质保已激活，待消费者领取'
        this.submitDialogShow = true
      } else {
        this.$router.push({ name: 'quality-assurance-ws' })
      }
    },
    init () {
      let params = {
        warrantyId: this.warrantyId
      }
      activityApi.getQaFeedbackInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          this.codeInfo = res.data.resultData.warrantyInfo
          // this.relationWarrantyId = this.codeInfo.relationWarrantyId || ''
        }
      })
    },
    qaUnbound () {
      this.$dialog.confirm({
        title: '操作提示',
        message: '该操作会导致车主提交质保无效，是否确定不质保并解除绑定？'
      })
        .then(() => {
          let data = {
            warrantyId: this.warrantyId
          }
          activityApi.qaUnbound(data).then(res => {
            if (res.data.resultCode === '0') {
              this.$dialog.alert({
                message: '解绑成功！'
              })
              this.init()
            } else {
              this.$notify({
                background: '#1989fa',
                message: res.data.resultMsg,
                className: 'notify-error-msg'
              })
            }
          })
        }).catch(() => {
        })
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  background-color: white;
  height: 100vh;
  // background: url('../../../assets/images/extra-logo.png');
  // background-size: 100% 200px;
  // background-repeat: no-repeat;
  // background-position-y: 46px;
}
.block-1{
  height: 216px;
}
.result-info{
  text-align: center;
  padding: 90px 0 20px 0;
  img{
    width: 80px;
  }
  .result-info-text{
    padding: 20px 0 5px 0;
    font-size: 16px;
  }
  .result-info-text2{
    border-radius: 5px;
    margin-top: 5px;
    display: inline-block;
    width: 110px;
    color: rgb(26, 164, 245);
    font-size: 13px;
    padding: 4px 0px;
    background-color: rgb(234, 242, 245);
  }
}
.info-box{
  position: relative;
  padding: 10px 0;
 // margin: 20px;
  margin: 0 20px;
  background-color: white;
  border-radius: 3px;
}
.btn{
  //width: 50%;
  text-align: center;
  border-radius: 3px;
  color: white;
  background-color: rgb(17, 114, 129);
}
.footer-operation{
  width: 100vw;
  display: flex;
  justify-content: space-evenly;
  div{
    padding: 12px 41px;
  }
}
.submit-btn{
  margin: 10px;
  padding: 12px;
}
.footer{
  width: 100vw;
  background-color: white;
  position: fixed;
  bottom: 0px;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-evenly;
}
.info-box-item{
  padding: 8px 10px ;
  display: flex;
  color: gray;
  .title{
    width: 70px;
    word-break: keep-all;
  }
}
.input-info{
  margin-top: 20px;
}
.info-item{
  margin: 15px 25px;
  display: flex;
  justify-content: space-between;
  .title{
    color: gray;
    min-width: 95px;
  }
}
.icon-bg{
  display: inline-block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #117281;
  font-size: 70px;
  color: white;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

  .block {
    width: 80%;
    height: auto;
    background-color: #fff;
    padding: 15px 20px;
    line-height: 1.5;
    border-radius: 5px;
    .wrapper-title{
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .wrapper-text{
      color:grey;
      margin-bottom: 10px;
    }
    .wrapper-button{
      text-align: right;
      button{
        border-radius: 10px;
      }
    }
  }
  }

</style>
